import { Container, Typography, CardMedia, Avatar, Skeleton } from '@mui/material';
import { PropTypes } from 'prop-types';
import { useState, useEffect } from 'react';

import axios from 'axios';
import LoadingComponent from '../components/LoadingComponent';
import Snackbar from '@mui/material/Snackbar';

import 'react-responsive-carousel/lib/styles/carousel.min.css';
import '@fontsource/roboto/400.css';


function Suspenso({ onChange, changeConfigs, colorPrimary, colorSecondary, colorTertiary }, props) {

  const [loading, setLoading] = useState(false);
  const [isSetTagPixel, setIsSetTagPixel] = useState(false);
  const [openSnack, setOpenSnack] = useState(false);
  const [msgSnack, setMsgSnack] = useState(false);
  const [nome, setNome] = useState("");
  const [urlBase, setUrlBase] = useState("");
  const [favoritos, setFavoritos] = useState(null);
  const [statusEstabelecimento, setStatusEstabelecimento] = useState("");
  const [background, setBackground] = useState("");

  const handleCloseLoading = () => {
    setLoading(false);
  };

  const handleSnack = (title) => {
    setMsgSnack(title);
    setOpenSnack(true);
    handleCloseLoading();
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnack(false);
  };

  useEffect(() => {
    // handleOpenLoading();

    let urlBase = window.location.href;
    if (urlBase.includes("?")) {
      let arrUrl = urlBase.split("?");
      urlBase = arrUrl[0];
    }

    if (urlBase.includes("itS=")) {
      const arrUrl = urlBase.split("itS=");
      if (!(localStorage.getItem("pS")) || (!isNaN(localStorage.getItem("pS")) && localStorage.getItem("pS") !== arrUrl[1])) {
        localStorage.setItem('iIts', arrUrl[1]);
        localStorage.setItem('pS', arrUrl[1]);
        onChange("", "cardapio");
        return
      }
    }

    if (urlBase.includes("localhost")) {
      urlBase = "https://meurestaurante.mely.online/";
    }

    setFavoritos(localStorage.getItem('fvUsr'));

    setUrlBase(urlBase);
    getConfig(urlBase);

    handleCloseLoading();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [favoritos]);

  const setTagPixel = (tagFacebook) => {
    const arrTag = tagFacebook.split("</script>")
    const facebookTag = arrTag[0].replaceAll("<script>", "");
    const imgTag = arrTag[1].replaceAll("<noscript>", "").replaceAll("</noscript>", "").replaceAll("`", "");

    if (imgTag && imgTag.includes("<img") && imgTag.includes("/>") && !isSetTagPixel) {
      var fbScript = document.createElement('script');
      fbScript.innerHTML = facebookTag;
      document.head.appendChild(fbScript);
      var noscript = document.createElement('noscript');
      noscript.innerHTML = imgTag;
      console.log(imgTag)
      document.head.appendChild(noscript);
      setIsSetTagPixel(true)
    }
  }

  const setAnalytics = (tagGoogle) => {
    var scriptElement1 = document.createElement('script');
    scriptElement1.src = "https://www.googletagmanager.com/gtag/js?id=" + tagGoogle;
    scriptElement1.async = true;

    var scriptElement2 = document.createElement('script');
    scriptElement2.innerHTML = "window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', '" + tagGoogle + "');";

    document.head.appendChild(scriptElement1);
    document.head.appendChild(scriptElement2);
  }

  const getConfig = (url) => {
    const urlBase = new URL(url).origin;
    axios.post(`https://gerenciador.mely.online/api/configuracoes-cliente.php`, {
      urlBase: urlBase,
    })
      .then(resp => {
        const response = resp.data;
        if (response && response.length > 0) {
          localStorage.setItem('Mn', response[0].NM_CT);
          localStorage.setItem('tD', response[0].TP_ENT);
          localStorage.setItem('Md', response[0].IDCT_ML);
          localStorage.setItem('UBs', `${urlBase}/api`);
          localStorage.setItem('UMs', response[0].URL_WT);
          localStorage.setItem('vlMnm', response[0].VL_MN);
          localStorage.setItem('eNbS', response[0].ENB_CT === "1");
          localStorage.setItem('eNbB', response[0].ENB_CP === "1");
          localStorage.setItem('eNbM', response[0].ENB_MN === "1");
          localStorage.setItem('tpLj', response[0].TP_CT);
          localStorage.setItem('pGap', response[0].ENB_PG === "1");

          document.title = response[0].NM_CT;
          setNome(response[0].NM_CT)
          response[0].TG_GG ?? setAnalytics(response[0].TG_GG)
          response[0].TG_FC ?? setTagPixel(response[0].TG_FC)
          const favicon = document.querySelector('link[rel="icon"]');
          favicon.href = `${urlBase.replaceAll("/api", "")}/imagens/logo-store.png?${new Date().getTime()}`;
          //
          changeConfigs(false, false, false, "ENABLED", response[0].ENB_CT === "1");
          changeConfigs(false, response[0].ENB_MN === "1");
          setBackground(response[0].IMG_BN);
          changeConfigs(false, false, response[0].TP_CT);

          getHorarios(urlBase)
        }
      })
      .catch(error => handleSnack("Não foi possivel conectar ao servidor, verifique sua conexão e tente novamente."));
  }

  const getHorarios = (url) => {
    axios.post(`${url}/api/horarios.php`, {
      idestabelecimentos: 1,
    })
      .then(response => {
        response = response.data

        if (localStorage.getItem("FxEst") === "1") {
          localStorage.setItem('sTA', `<b style="color:#A41D1D">Fechado temporariamente</b>`);
          setStatusEstabelecimento(`<b style="color:#A41D1D">Fechado temporariamente</b>`)
          return
        }

        const horariosArray = response[0].horarios.split(",");
        const d = new Date();
        let diasemana
        if (d.getDay() === 0) {
          diasemana = horariosArray[6]
        } else {
          diasemana = horariosArray[d.getDay() - 1]
        }
        if (diasemana === "Fechado") {
          localStorage.setItem('sTA', `<b style="color:#A41D1D">Fechado</b>`);
          setStatusEstabelecimento(`<b style="color:#A41D1D">Fechado</b>`)
        } else {
          var unix = Math.round(+new Date() / 1000);
          const horarios = diasemana.split(" às ");
          const horario1 = horarios[0].split(":");
          var unix1 = Math.round(+new Date(d.getFullYear(), d.getMonth(), d.getDate(), horario1[0], horario1[1]) / 1000);
          const horario2 = horarios[1].split(":");
          var unix2 = Math.round(+new Date(d.getFullYear(), d.getMonth(), d.getDate(), horario2[0], horario2[1]) / 1000);

          if (parseInt(horario2[0]) < parseInt(horario1[0]) || (horarios[0] === "00:00" && horarios[1] === "00:00")) {
            unix2 += 86400
          }

          const arrTime = localStorage.getItem("tD").split("(")
          const tempo = arrTime[1].replaceAll(")", "")

          if (unix > unix1 && unix < unix2) {
            localStorage.setItem('sTA', `<b style="color:#33540E">Aberto</b> até ${horarios[1]} • ${tempo}`);

            setStatusEstabelecimento(`<b style="color:#33540E">Aberto</b> até ${horarios[1]} • ${tempo}`)
          } else {
            localStorage.setItem('sTA', `<b style="color:#A41D1D">Fechado</b> abre às ${horarios[0]}`);
            setStatusEstabelecimento(`<b style="color:#A41D1D">Fechado</b> abre às ${horarios[0]}`)
          }
        }

      })
      .catch(error => handleSnack("Não foi possivel conectar ao servidor, verifique sua conexão e tente novamente."));
  }


  return (
    <Container>

      <CardMedia component="img" height="120" image={`${urlBase.replaceAll("/api", "")}/imagens/${background}?${new Date().getTime()}`} style={{ position: "absolute", top: "0", left: "0", right: "0" }} onError={({ currentTarget }) => {
        currentTarget.onerror = null;
        currentTarget.src = "https://dedicado.mely.online/imagens/background.png";
      }} />

      <LoadingComponent open={loading} />

      <Snackbar
        open={openSnack}
        autoHideDuration={3000}
        onClose={handleClose}
        message={msgSnack}
      />

      <div style={{ height: "130px" }}></div>

      {/* Cabeçalho Restaurante */}

      <div style={{ display: "flex", alignItems: "center" }}>
        <div style={{ height: "100%", width: "70px", borderRadius: "4px" }}>
          <Avatar src={`${urlBase.replaceAll("/api", "")}/imagens/logo-store.png?${new Date().getTime()}`} style={{ margin: "auto", width: "70px", height: "70px", fontSize: "15px" }} />

          <div style={{ height: "2px" }}></div>

        </div>
        <div style={{ flexGrow: 1 }}>
          <Typography style={{ fontSize: "16px", color: "#1B1B1B", display: "flex", alignItems: "center", fontWeight: "bold" }}>

            {nome ? (
              <Typography style={{ paddingLeft: "10px", fontWeight: "700" }}>{nome}
              </Typography>
            ) : (
              <>
                &nbsp;&nbsp; <Skeleton animation="wave" height={40} width="155px" />
              </>
            )}
          </Typography>
          {statusEstabelecimento ? (
            <>
              <div style={{ height: "2px" }}></div>
              <Typography style={{ paddingLeft: "10px", fontSize: "11px", color: "#999" }} dangerouslySetInnerHTML={{ __html: statusEstabelecimento }} />
            </>
          ) : (
            <Skeleton animation="wave" height={21} width="100%" />
          )}

        </div>

      </div>

      <Typography style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", margin: "0" }}>
        <Typography style={{ textAlign: "center", fontSize: "14px", color: "rgba(0,0,0,.3)", minWidth: "300px" }}>

          <img alt="suspenso" src="https://mely.online/imagens/sad-face.png" style={{ width: 80 }} />

          <div style={{ height: "10px" }}></div>
          Este cardápio está temporariamente fora do ar.

          <div style={{ height: "20px" }}></div>

        </Typography>
      </Typography>
      <div style={{ height: "100px" }}></div>

    </Container>
  );
}

Suspenso.propTypes = {
  windows: PropTypes.func,
};

export default Suspenso;